import { render, staticRenderFns } from "./ApplicationDocumentsCreated.vue?vue&type=template&id=14071718&"
import script from "./ApplicationDocumentsCreated.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocumentsCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports